// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2GJCs","empty":"ModalGraph_empty__2PMwu"};